import Request from '@/utils/request'
const Api = {
    goodsList: '/goods/mobile/MobGoods/GetGoodsList',  // 商品列表
    goodsDetail: '/goods/mobile/MobGoods/GetGoods',  // 商品详情
    // goodsComment: '/order/mobile/MobOrder/GetCommentListByGoodsId',  // 商品评论
    goodsComment: '/other/manager/b-order/GetCommentListByGoodsId',  // 商品评论
    // goodsTypeList: '/goods/mobile/MobGoods/GetGoodsTypeListByShopId',  // 根据店铺ID获取商品分类信息
    goodsTypeList: '/other/manager/b-good/getGoodsTypeHaveGood',  // 根据店铺ID获取商品分类信息
    shopInfo: '/admin/tenant/',  // 店铺信息
    cartList: '/order/mobile/MobCart/GetList',  // 购物车
    cartDelete: '/order/mobile/MobCart/Delete',  // 购物车删除
    cartAdd: '/other/manager/b-order/addCart',  // 购物车添加
    userext: '/admin/userext',  // 用户信息
    orderPreInfo: '/order/mobile/MobOrder/GetOrderPreInfo',  // 确认订单信息
    creatOrder: '/order/mobile/MobOrder/CreatOrder',  // 创建订单
    statisticsLvCCPorts4Mobile: '/asset/community/statisticsLvCCPorts4Mobile/',  // 充电桩数据
    lvCcOrderInfo: '/asset/device/getLvCcOrderInfo/',  // 充电桩订单详情
    startCharging: '/asset/device/startCharging/',  // 开始充电
    stopCharge: '/asset/device//stopCharge/',  // 停止充电
    chargingPortStatus: '/asset/device/getChargingPortStatus',  // 获取当前插座充电状态
    deviceInfo: '/asset/device/',  // 设备信息
    dict: '/admin/dict/type/',  // 字典
    upload: '/file/upload',  // 附件上传
    // orderList: '/order/mobile/MobOrder/GetOrderListForUser',  // 订单列表
    orderList: '/other/manager/b-order/getOrderList',  // 订单列表
    orderDetail: '/other/manager/b-order/getById',  // 订单详情
    jobplancalendarstatus: '/jobplan/jobplancalendarstatus/',  // 服务信息
    updateStatus: '/other/manager/b-order/updateStatus',  // 更新订单状态
    statusList: '/other/manager/b-order/getStatusList',  // 售后记录
    delOrder: '/order/mobile/MobOrder/DelOrder',  // 删除订单
    xpay: '/xpay/order',  // 发起支付
    chargeDetail: '/xpay/costPayPlan/getShopPayOrder',  // 充电详情
    appreciate: '/other/otherappreciate/',  // 赞赏排行榜
    updateOtherAppreciate: '/other/otherappreciate/updateOtherAppreciate',  // 赞赏 表扬 批评
    selectNotice: '/notice/informationnotice/selectNotice',  // 通知公告
    noticeAnnounceDetail: '/notice/informationnotice/',  // 通知公告详情
    selectQuestionnaire: '/information/questionnaire/selectQuestionnaire',  // 问卷调查
    questionSurveyDetail: '/information/answer/selectAnswerDetailApp',  // 问卷调查详情
    questionSurveyAdd: '/information/answer/saveAnswer',  // 新增问卷调查
    dictLabels: '/admin/dict/labels'  // 字典
}
export const goodsList = params => Request.post(Api.goodsList, params)
export const goodsDetail = params => Request.post(Api.goodsDetail, params)
export const goodsComment = params => Request.get(Api.goodsComment, params)
export const goodsTypeList = params => Request.get(Api.goodsTypeList, params)
export const shopInfo = params => Request.get(Api.shopInfo + params.ShopId, params)
export const cartList = params => Request.post(Api.cartList, params)
export const cartDelete = params => Request.post(Api.cartDelete, params)
export const cartAdd = params => Request.post(Api.cartAdd, params)
export const userext = params => Request.get(Api.userext, params)
export const orderPreInfo = params => Request.post(Api.orderPreInfo, params)
export const creatOrder = params => Request.post(Api.creatOrder, params)
export const statisticsLvCCPorts4Mobile = params => Request.get(Api.statisticsLvCCPorts4Mobile + params.CommunityId, params)
export const lvCcOrderInfo = params => Request.get(Api.lvCcOrderInfo + params.ShopOrderId, params)
export const startCharging = params => Request.get(Api.startCharging + params.ShopOrderId, params)
export const stopCharge = params => Request.get(Api.stopCharge + params.ShopOrderId, params)
export const chargingPortStatus = params => Request.get(Api.chargingPortStatus, params)
export const deviceInfo = params => Request.get(Api.deviceInfo + params.id)
export const dict = params => Request.get(Api.dict + params.orders_status, params)
export const upload = params => Request.file(Api.upload, params)
export const orderList = params => Request.post(Api.orderList, params)
export const orderDetail = params => Request.get(Api.orderDetail, params)
export const jobplancalendarstatus = params => Request.get(Api.jobplancalendarstatus + params.id, params)
export const updateStatus = params => Request.post(Api.updateStatus, params)
export const statusList = params => Request.get(Api.statusList, params)
export const delOrder = params => Request.post(Api.delOrder, params)
export const xpay = params => Request.post(Api.xpay, params)
export const chargeDetail = params => Request.get(Api.chargeDetail, params)
export const appreciate = params => Request.get(Api.appreciate + params.userName, params)
export const updateOtherAppreciate = params => Request.post(Api.updateOtherAppreciate, params)
export const selectNotice = params => Request.post(Api.selectNotice, params)
export const noticeAnnounceDetail = params => Request.get(Api.noticeAnnounceDetail + params.id, params)
export const selectQuestionnaire = params => Request.post(Api.selectQuestionnaire, params)
export const questionSurveyDetail = params => Request.post(Api.questionSurveyDetail, params)
export const questionSurveyAdd = (params, data) => Request.post(Api.questionSurveyAdd + '?roomId=' + params.roomId, data)
export const dictLabels = (data) => Request.post(Api.dictLabels, data)

